import { useQuery, UseQueryResult } from 'react-query';
import { GroupLinkDto, UsersApi } from '../../../api-client';

type UseGetUserGroups = (usersApi: UsersApi, userId: string) => UseQueryResult<GroupLinkDto[]>;

export const useGetUserGroups: UseGetUserGroups = (usersApi, userId) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useQuery(
    [`user-${userId}-groups`],
    async () => usersApi.getUserGroupLinks(tenantId, userId).then(({ data }) => data),
    {
      keepPreviousData: false,
      retry: false,
    },
  );
};
